import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'
import { browserDateConvert } from 'src/Entities/CommonEntities'

const API_FORMDATA = Axios.getInstanceForFormData
const API = Axios.getInstance

export const getAllCompFrequency = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_COMP_FREQUENCY)
        .then(response => response)
        .catch(err => err)
}

export const GetAllComplianceFor = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_COMP_FOR)
        .then(response => response)
        .catch(err => err)
}

export const GetAllCompCategory = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_COMP_CATEGORY)
        .then(response => response)
        .catch(err => err)
}

export const GetAllCompSubCategory = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_COMP_SUB_CATEGORY)
        .then(response => response)
        .catch(err => err)
}
export const GetAllCompUom = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_COMP_UOM)
        .then(response => response)
        .catch(err => err)
}

export const createCompliance = (data, loginId, complianceId) => {
    const istOffset = 5.5 * 60 * 60 * 1000
    data.inActiveDate = data.inActiveDate ? new Date(data.inActiveDate.getTime() + istOffset) : null
    const params = { loginId, complianceId }
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_COMPLIANCE, data, { params })
        .then(response => response)
        .catch(err => err)
}

export const createUserCompliance = (data) => {
    // const istOffset = 5.5 * 60 * 60 * 1000
    // data.inActiveDate = data.inActiveDate ? new Date(data.inActiveDate.getTime() + istOffset) : null
    // const params = { loginId, complianceId }
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_USER_COMPLIANCE, data)
        .then(response => response)
        .catch(err => err)
}

export const GetAllComp = (regulatoryId, frequency, userId, orgId, selectMonth, isCutoff, type) => {
    const rawParams = {
        regulatoryId,
        frequency,
        userId,
        orgId,
        dueByDate: selectMonth,
        isCutoff,
        type
    }

    // ✅ Filter out null or undefined values
    const filteredParams = Object.fromEntries(
        Object.entries(rawParams).filter(([_, value]) => value !== null && value !== undefined)
    )
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.GET_ALL_COMP, filteredParams, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response)
        .catch(err => err)
}
export const GetCompById = (complianceId, isAdmin, userId) => {
    const params = { complianceId, isAdmin, userId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_COMP_BY_ID, { params })
        .then(response => response)
        .catch(err => err)
}
export const GetCompByRegId = (regId) => {
    const params = { regId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_COMP_BY_REG_ID, { params })
        .then(response => response)
        .catch(err => err)
}
export const GetOneTimeCompliance = (regId) => {
    const params = { regId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ONE_TIME_COMPLIANCE, { params })
        .then(response => response)
        .catch(err => err)
}
export const processOneTimeCompliance = (data) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.POST_ONE_TIME_COMPLIANCE, data)
        .then(response => response)
        .catch(err => err)
}
export const GetSelectedCompliance = (orgId, regId) => {
    const params = { orgId, regId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_SELECTED_COMPLIANCE, { params })
        .then(response => response)
        .catch(err => err)
}
export const GetStatusTabCount = (orgId, regId) => {
    const params = { orgId, regId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_STATUS_TAB_COUNT, { params })
        .then(response => response)
        .catch(err => err)
}
export const SubmitSeedCompliance = (data, orgId, loginId, regId) => {
    const params = { orgId, loginId, regId }
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.SUBMIT_SEEDING_COMPLIANCE, { complianceTemplates: data }, { params })
        .then(response => response)
        .catch(err => err)
}
export const GetCompByIdAnswer = (complianceId, dueBy, userId) => {
    const convertedDate = browserDateConvert(dueBy)

    const params = { complianceId, dueBy: convertedDate, userId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_COMP_BY_ID, { params })
        .then(response => response)
        .catch(err => err)
}
export const GetComplianceTimeline = (complianceId, dueby) => {
    const params = { complianceId, dueby }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_COMPLIANCE_TIMELINE, { params })
        .then(response => response)
        .catch(err => err)
}
export const CreateComplianceCalendar = (complianceCalendarData) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_COMPLIANCE_CALENDAR, complianceCalendarData, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
        .catch((err) => err)
}
export const CreateComplianceCalendarOverDue = (complianceCalendarOverDueData) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_COMPLIANCE_CALENDAR_OVERDUE, complianceCalendarOverDueData, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
        .catch((err) => err)
}
export const approveCompliance = (data) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.APPROVE_COMPLIANCE, data)
        .then((response) => response)
        .catch((err) => err)
}

export const updateModifiedDueDate = (data) => {
    return API(Endpoints.API_ENDPOINT)
        .put(Endpoints.UPDATE_MODIFIED_DUE_DATE, data)
        .then((response) => response)
        .catch((err) => err)
}
export const GetModifiedDueDate = (complianceDetailId, dueBy) => {
    const params = { complianceDetailId, dueBy }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_MODIFIED_DUE_DATE, { params })
        .then(response => response)
        .catch(err => err)
}

// Complaince Preview / Transfer Compliance
// /Complaince/CompliancePreview?userId=10&orgId=1&complianceType=1
export const GetAllCompliancePreview = (userId, orgId, complianceType, roleId) => {
    const params = { userId, orgId, complianceType, roleId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_COMPLIANCE_PREVIEW, { params })
        .then(response => response)
        .catch(err => err)
}

// /user/GetDepartmentByRole?roleId=-3%27
export const GetAllDepartmentByRole = (roleId, orgId) => {
    const params = { roleId, orgId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_DEPARTMENT_BY_ROLE_ID, { params })
        .then(response => response)
        .catch(err => err)
}

// /user/GetUsersByRole?roleId=-3&orgId=1&deptId=6%27
export const GetAllUserByRole = (roleId, orgId, deptId) => {
    const params = { roleId, orgId, deptId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_USER_BY_ROLE_ID, { params })
        .then(response => response)
        .catch(err => err)
}

// /Complaince/TransferCompliance?orgId=32&loginId=323
export const TransferCompliance = (orgId, loginId, payload) => {
    const params = { orgId, loginId }
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.POST_TRANSFER_COMPLIANCE, payload, { params })
        .then(response => response)
        .catch(err => err)
}
export const TransferBody = (orgId, loginId, payload) => {
    const params = { orgId, loginId }
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.POST_TRANSFER_BODY, payload, { params })
        .then(response => response)
        .catch(err => err)
}

export const ViewTransferComplianceDetails = (notificationId) => {
    const params = { notificationId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.VIEW_TRANSFER_COMPLIANCE_DETAIL, { params })
        .then(response => response)
        .catch(err => err)
}
export const AcknowledgeTransferCompliance = (notificationId, loginId) => {
    const params = { notificationId, loginId }
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.ACKNOWLEDGE_TRANSFER_COMPLIANCE_DETAIL, {}, { params })
        .then(response => response)
        .catch(err => err)
}
export const TransferComplianceDetail = (payload) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.POST_TRANSFER_COMPLIANCE_DETAIL, payload)
        .then(response => response)
        .catch(err => err)
}

export const GetDueTodayCompliances = (orgId, userId) => {
    const params = { orgId, userId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_DUE_TODAY_COMPLIANCES, { params })
        .then(response => response)
        .catch(err => err)
}
